var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"sctLogin\">\n<img class=\"sctLogin_header_logo\" src=\"" + require("../../../assets/sct/Logo_SMARTCorporateTravel.svg") + "\">\n<div class=\"sctFormMessage\">\n<h3 class=\"sctFormMessage_title\">Thanks for signing up!</h3>\n<p class=\"sctLogin_header_subTitle\">An email has been sent to the address supplied.\n<br/>\n<br/>\nTo verify your account please click the link in the email.\n<br/>\nThen, click <a href=\"/#/login\">HERE</a> to login.\n<br/>\n<br/>\nAccounts must be verified BEFORE you can login.\n<br/>\n<br/>\nIf you have not received your verification email <br/>please check your Junk/SPAM folder or contact\n<a href=\"mailto:info@smartcorporatetravel.com\">info@smartcorporatetravel.com</a>\n</p>\n</div>\n</div>\n";
var id1="sct/sctSignUp/sctSignUpSuccess.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/sct/sctSignUp/sctSignUpSuccess.html
// module id = 1297
// module chunks = 1